// extracted by mini-css-extract-plugin
module.exports = {"container":"finalLinks_container___ApWJ","column":"finalLinks_column__3dURe"};